/**
 * @file @/common/constants.ts
 * @description 公共常量
 * @author heyongjie@baidu.com
 */

// eslint-disable-next-line no-underscore-dangle
export const isSubApp = !!window.__POWERED_BY_QIANKUN__;

// RUN_PLATFORM 是 webpack 打包时利用 webpack plugin 注入尽量的变量
export const isEop = RUN_PLATFORM === 'EOP';

export const EMPTY_TEXT = '-';

export const VALIDATION_CODE = 'BceValidationException';


export const CHARGE_TYPE_MAP: Record<string, string | Record<string, string>> = {
    'cpt1': '按时长',
    'cpt2': '包年包月',
    'cpt3': '按量按时长',
    'cpc': '按消耗量',
    'cpt1_cdn_bandwidth': 'CDN按带宽计费',
    'peakbandwidth_avg': '月均值',
    'eip_postpay_nettraffic': '按需按使用流量计费',
    'eip_prepay_bandwidth': '包年包月按带宽计费',
    'eip_postpay_bandwidth': '按需按带宽计费',
    'peakbandwidth_percent_95': '按月95峰值带宽计费',
    'lss_netraffic': '按使用流量计费',
    'lss_bandwidth': '按日峰值带宽计费',
    'lss_peakbandwidth_top_1': '大客户月峰值计费',
    'lss_peakbandwidth_avg': '月均值',
    'lss_peakbandwidth_percent_95': '95%峰值',
    'lss_peakbandwidth_top_4': '第4峰值',
    'vod_netraffic': '按使用流量计费',
    'vod_bandwidth': '按日峰值带宽计费',
    'vod_peakbandwidth_percent_95': '按月峰值带宽计费',
    'onetime': '一次性',
    'ai_daily': '按日',
    // BML和众测的计费方式属于预付费中的按项目，因此增加新的project类型
    // 不同服务按项目计费的文案不同
    'project': {
        BML: '按个数',
        MAT: '按次计费',
        QSS: '按次计费',
        AAT: '按次计费',
        FACE: '按次计费',
    },
    'package': '量包',
    // EIP计费变更，仅前端使用
    'netraffic': '按流量',
    'bandwidth': '按带宽',
    // 竞价实例相关
    'bidding': '按时长-抢占',
};

export const TIMEUNIT_MAP: Record<string, string> = {
    DAY: '天',
    MONTH: '个月',
    YEAR: '年',
};

export const isConsoleOnline = location.host === 'console.bce.baidu.com';

export const UNLIMITED_QUOTA = 999999999999;
